import { CronSettingListPage } from "@/features/cron-setting/pages/CronSettingListPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/cron-setting/")({
	component: CronSettingListPage,
});
